import actions from "@/store/modules/os-bath/actions";

export default {
    actions
}